import { AzureAuthConfiguration } from "@datamole/wds-azure-auth";

import { config } from "@/config";

export const azureAuthConfiguration: AzureAuthConfiguration = {
    authorityUrl: config.AZURE_AD_AUTH_AUTHORITY_URL,
    clientId: config.AZURE_AD_AUTH_CLIENT_ID,
    redirectUrl: config.AZURE_AD_AUTH_REDIRECT_URL,
    postLogoutRedirectUrl: config.AZURE_AD_AUTH_POST_LOGOUT_REDIRECT_URL,
};
